import React from "react";
import { Row, Col, Divider } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import Title from "antd/lib/typography/Title";
import { friendlyNumber, friendlyPrice } from "../../../utils/calculators";
import { textGrey } from "../../theme";
import Text from "antd/lib/typography/Text";

const SummaryDivider = <Divider style={{ margin: "0.75rem 0" }} />;

const ProductTitle = ({ children }) => (
    <div style={{ marginBottom: "0.5rem" }}>
        <Text strong>{children}</Text>
    </div>
);

const PricingRow = props => {
    const { summary, children } = props;
    return (
        <Row
            justify="space-between"
            type="flex"
            style={{ fontSize: summary ? "1rem" : "0.875rem" }}
        >
            {children}
        </Row>
    );
};

const PricingItem = props => {
    const { value, children } = props;
    return (
        <Col
            span={value ? 6 : 18} //value only take 1/3 of row space
            style={{
                marginBottom: "0.5rem",
                textAlign: value ? "right" : "left",
                fontWeight: value ? "600" : "normal",
            }}
        >
            {children}
        </Col>
    );
};

const CostBreakdownTable = props => {
    const { inbound, outbound, total, dueToday } = props;

    const inboundSummary = inbound ? (
        <div style={{ marginTop: "0.5rem" }}>
            <ProductTitle>{`Inbound Plan`}</ProductTitle>
            <PricingRow>
                <PricingItem>{`${inbound.planName} - ${friendlyNumber(
                    inbound.domains
                )} protected domains`}</PricingItem>
                <PricingItem value>{friendlyPrice(inbound.basePrice)}</PricingItem>
            </PricingRow>
        </div>
    ) : null;

    const outboundSummary = outbound ? (
        <div style={{ marginTop: "0.5rem" }}>
            <ProductTitle>{`Outbound Plan`}</ProductTitle>
            <PricingRow>
                <PricingItem>{`${outbound.planName} - ${friendlyNumber(
                    outbound.includedEmails
                )} included emails`}</PricingItem>
                <PricingItem value>{friendlyPrice(outbound.basePrice)}</PricingItem>
            </PricingRow>
            {outbound.extraEmails > 0 && (
                <PricingRow>
                    <PricingItem>
                        {friendlyNumber(outbound.extraEmails)}
                        {` extra emails (estimated)`}
                    </PricingItem>
                    <PricingItem value>{friendlyPrice(outbound.extraPrice)}</PricingItem>
                </PricingRow>
            )}
        </div>
    ) : null;

    const overallSummary = (
        <PricingRow summary>
            <PricingItem>{`Total${total > dueToday ? " (estimated)" : ""}`}</PricingItem>
            <PricingItem value>{friendlyPrice(total)}*</PricingItem>
        </PricingRow>
    );

    const dueTodaySummary = (
        <div>
            <div style={{ marginTop: "2rem" }}>
                <Title level={4}>What you'll pay today</Title>
                <Paragraph>
                    Your plan cost is covered from today to the same day of the next month. Here's
                    what you'll pay today:
                </Paragraph>
                {SummaryDivider}
                <PricingRow summary>
                    <PricingItem>Due today</PricingItem>
                    <PricingItem value>{`${friendlyPrice(dueToday)}*`}</PricingItem>
                </PricingRow>

                <div
                    style={{ fontSize: "0.85rem", marginTop: "0.5rem", color: textGrey }}
                >{`*Taxes may apply`}</div>
            </div>
        </div>
    );
    return (
        <div>
            <Title level={4}>Detailed cost breakdown</Title>
            <Paragraph>
                {`The exact amount you pay will vary month-to-month based on your outbound
                        sending volume (if applicable). Here's an estimate of your monthly cost:`}
            </Paragraph>
            {inboundSummary}
            {outboundSummary}
            {SummaryDivider}
            {overallSummary}
            {dueTodaySummary}
        </div>
    );
};

export default CostBreakdownTable;
